import { motion } from "framer-motion";
import React from "react";

import { ScrollArea } from "@/components";
import { useI18n } from "@/context/i18n";
import { cn } from "@/lib/utils";

import { PasswordCard } from "./components";
import { ProfileCard } from "./components/profile-card";
import { useSettings } from "./settings.hooks";

export const SettingsPage: React.FC = () => {
  const { t } = useI18n();
  const {
    shouldRenderPasswordForm,
    profileForm,
    passwordForm,
    mfaMethodOptions,
    fileInputRef,
    file,
    onCropComplete,
    onSubmitProfile,
    mfaEnabled,
    onSubmitPassword,
    isQrCodeVisible,
    onCloseQrCode,
    mfaKey,
    personTypeOptions,
    personType,
  } = useSettings();

  return (
    <div className="flex flex-col h-full w-full space-y-6 p-4">
      <div className="flex flex-col space-y-2">
        <h1 className="text-3xl font-bold tracking-tight">
          {t("settings.title")}
        </h1>
        <p className="text-muted-foreground">{t("settings.description")}</p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className="flex h-full overflow-hidden max-h-screen">
          <ScrollArea className="flex-1">
            <div
              className={cn(
                "w-full grid grid-cols-1 md:grid-cols-2 gap-6 flex-1",
                {
                  "md:grid-cols-1": !shouldRenderPasswordForm,
                }
              )}
            >
              <ProfileCard
                profileForm={profileForm}
                mfaMethodOptions={mfaMethodOptions}
                file={file}
                fileInputRef={fileInputRef}
                onCropComplete={onCropComplete}
                onSubmitProfile={onSubmitProfile}
                mfaEnabled={mfaEnabled}
                isQrCodeVisible={isQrCodeVisible}
                onCloseQrCode={onCloseQrCode}
                mfaKey={mfaKey}
                personTypeOptions={personTypeOptions}
                personType={personType}
              />
              {shouldRenderPasswordForm && (
                <PasswordCard
                  passwordForm={passwordForm}
                  onSubmitPassword={onSubmitPassword}
                />
              )}
            </div>
          </ScrollArea>
        </div>
      </motion.div>
    </div>
  );
};
